var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99999 19.5999C15.3019 19.5999 19.6 15.3018 19.6 9.9999C19.6 4.69797 15.3019 0.399902 9.99999 0.399902C4.69806 0.399902 0.399994 4.69797 0.399994 9.9999C0.399994 15.3018 4.69806 19.5999 9.99999 19.5999ZM14.4485 8.44843C14.9172 7.9798 14.9172 7.22 14.4485 6.75137C13.9799 6.28274 13.2201 6.28274 12.7515 6.75137L8.79999 10.7028L7.24852 9.15137C6.77989 8.68274 6.02009 8.68274 5.55147 9.15137C5.08284 9.62 5.08284 10.3798 5.55147 10.8484L7.95147 13.2484C8.42009 13.7171 9.17989 13.7171 9.64852 13.2484L14.4485 8.44843Z",
    fill: "#509E2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.eba7aac2e3d2ec5d05f893c10aa90318.svg";
export { ForwardRef as ReactComponent };